import type { CaseStatus, Severity } from '../../shared/types'

const statusLabel: Record<CaseStatus, string> = {
  open: 'Open',
  in_progress: 'In Progress',
  closed: 'Closed',
}
const statusColor: Record<CaseStatus, string> = {
  open: 'var(--status-open)',
  in_progress: 'var(--status-in-progress)',
  closed: 'var(--status-closed)',
}
// Yellow fills need dark text to stay legible.
const statusInk: Record<CaseStatus, boolean> = { open: false, in_progress: true, closed: false }

export function StatusBadge({ status }: { status: CaseStatus }) {
  return (
    <span
      className="badge"
      style={{ background: statusColor[status], color: statusInk[status] ? 'var(--ink)' : '#fff' }}
    >
      {statusLabel[status]}
    </span>
  )
}

const sevColor: Record<Severity, string> = {
  minor: 'var(--sev-minor)',
  moderate: 'var(--sev-moderate)',
  major: 'var(--sev-major)',
}
const sevInk: Record<Severity, boolean> = { minor: false, moderate: true, major: false }

export function SeverityBadge({ severity }: { severity: Severity | null }) {
  if (!severity) return <span style={{ color: 'var(--gray)' }}>—</span>
  return (
    <span className="badge" style={{ background: sevColor[severity], color: sevInk[severity] ? 'var(--ink)' : '#fff' }}>
      {severity[0].toUpperCase() + severity.slice(1)}
    </span>
  )
}
